import { useEffect, useState } from 'react';

/** Avoid a one-frame spinner flash on fast local/cached requests. */
export function LoadingIndicator({ loading }: { loading: boolean }) {
  return loading ? <PendingIndicator /> : null;
}

function PendingIndicator() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 150);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;
  return (
    <span
      role="status"
      aria-label="Updating results"
      className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2"
    >
      <span className="block h-4 w-4 animate-spin rounded-full border-2 border-line-strong border-t-brand-500" />
    </span>
  );
}
